import React from "react";
import { Modal, Row, Col } from "antd";
import moment from "moment";

const AttendanceInfoModal = ({ isVisible, onClose, data }) => {
  const formatTime = (time) => (time ? moment(time, 'HH:mm:ss').format('hh:mm A') : '-');

  if (!isVisible) {
    return null; // Return null if the modal should not be visible
  }

  return (
    <div className="modal custom-modal fade show" id="attendance_details_modal" tabIndex="-1" role="dialog" style={{ display: isVisible ? 'block' : 'none' }}>
      <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "60%" }}>
        <div className="modal-content h-100">
          <div className="modal-header">
            <h5 className="modal-title">
              Attendance Details - {moment(data.attendance_date).format('ddd, DD MMM YYYY')}
            </h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body" style={{ maxHeight: 'calc(100vh - 120px)', overflowY: 'auto' }}>
            <div style={{ padding: '10px 0' }}>
              <Row style={{ borderBottom: '1px solid #ddd', paddingBottom: '10px' }}>
                <Col span={12}>
                  <strong>First Check-In:</strong> {data.check_in_time}
                </Col>
                <Col span={12}>
                  <strong>Last Check-Out:</strong> {data.check_out_time}
                </Col>
              </Row>

              <Row style={{ marginTop: '10px', borderBottom: '1px solid #ddd', paddingBottom: '10px' }}>
                <Col span={24}>
                  <strong>Total Hours:</strong> {data.total_hours} Hrs
                </Col>
              </Row>

              <div style={{ marginTop: '20px' }}>
                <h4 style={{ borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>Activity Log</h4>
                {data.activity_log.length > 0 ? (
                  data.activity_log.map((activity, index) => (
                    <Row key={index} style={{ padding: '5px 0', borderBottom: index !== data.activity_log.length - 1 ? '1px solid #eee' : 'none' }}>
                      <Col span={8}>
                        <span style={{ color: activity.type === 'in' ? 'green' : 'red' }}>
                          {activity.type === 'in' ? 'Check-In' : 'Check-Out'}
                        </span>
                      </Col>
                      <Col span={8}>{formatTime(activity.time)}</Col>
                      <Col span={8}><em>{activity.location || 'Unknown Location'}</em></Col>
                    </Row>
                  ))
                ) : (
                  <p>No activity recorded.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceInfoModal;
